var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"shopTop"}},[_c('van-row',{ref:"top",staticClass:"top"},[_c('div',{staticClass:"h2"},[_c('h3',[_vm._v("店铺公告")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }